module.exports = __webpack_public_path__ + "static/img/my-service.0a639a23.png";